import React from 'react';
import styles from './downloads-center.component.module.scss';

interface Props {
    fileNames: string[];
}

export const ContentsDisclosure: React.FC<Props> = ({ fileNames }) => (
    <ul className={styles['contents']}>
        {fileNames.map((n) => (
            <li key={n}>{n}</li>
        ))}
    </ul>
);
